import React from 'react';
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import CardLayout from "../components/CardLayout.js";


export default function LogoutHappens (props) {

  return (
    <CardLayout title="Sei stato disconnesso">
        <p>
          Torna presto a trovarci.
        </p>
        <Button as={Link} to="/login" variant="primary" type="submit">
          Accedi
        </Button>
    </CardLayout>
  );
}
